<template>
  <b-taginput
    :data="filteredApps"
    :placeholder="$t('compSuperadminSettingsActiveApps.label')"
    :allow-new="false"
    ref="apptaginput"
    v-model="buffer"
    :open-on-focus="true"
    @input="$emit('input', buffer)"
    rounded
    icon="caret-right"
    @typing="getFilteredApps"
    autocomplete
  >
    <template v-slot="props">
      {{ $t(props.option) }}
    </template>
    <template #selected="props">
      <b-tag
        v-for="(tag, index) in props.tags"
        :key="index"
        rounded
        :tabstop="false"
        ellipsis
        closable
        @close="$refs.apptaginput.removeTag(index, $event)"
      >
        {{ tag }}
      </b-tag>
    </template>
  </b-taginput>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'
import { ALL_APPS } from '@/models/ActiveApps.js'

export default {
  name: 'ActiveApps',
  inject: ['$validator'],
  props: {
    value: Array
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      buffer: this.value,
      filteredApps: []
    }
  },
  computed: {
    allApps: function () {
      return ALL_APPS.map((app) => app.appname)
    }
  },
  methods: {
    getFilteredApps (text) {
      this.filteredApps = this.allApps.filter((appname) => {
        return appname.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = this.value
      },
      deep: true
    }
  },
  mounted () {
    this.buffer = this.coreStore.setting('global', 'ACTIVE_APPS').value
    this.filteredApps = this.allApps
  }
}
</script>
